import { EQUITY_CHANGES_ROWS } from "../consts";
import type { EquityChangesRow, EquityMoney } from "../types/reports";

export const EQUITY_VALUE_KEYS = [
  "share_capital",
  "share_premium",
  "treasury_shares",
  "oci_components",
  "retained_earnings",
  "other_capital",
  "minority_interest",
  "total",
] as const;

export interface EquityTableRow {
  key: string;
  code: string;
  labelKey: string;
  indent: number;
  bold: boolean;
  italic: boolean;
  cells: string[];
}

export interface EquityCardFigures {
  opening: EquityMoney;
  profit: EquityMoney;
  revaluation: EquityMoney;
  closing: EquityMoney;
}

const DASH = "—";

export function formatEquityThousands(value: EquityMoney): string {
  if (value === null) return DASH;
  const amount = Number(value);
  if (!Number.isFinite(amount)) return DASH;
  const thousands = Math.round(amount / 1000);
  if (thousands === 0) return "0";
  return thousands.toLocaleString("ru-RU");
}

export function buildEquityTableRows(apiRows: EquityChangesRow[]): EquityTableRow[] {
  const rowsByCode = new Map(apiRows.map((row) => [row.code, row]));
  return EQUITY_CHANGES_ROWS.map(function toTableRow(config, index) {
    const apiRow = config.code ? rowsByCode.get(config.code) : undefined;
    const cells = EQUITY_VALUE_KEYS.map((valueKey) =>
      apiRow ? formatEquityThousands(apiRow[valueKey]) : DASH,
    );
    return {
      key: config.code ?? `label-${index}`,
      code: config.code ?? "",
      labelKey: config.labelKey,
      indent: config.indent ?? 0,
      bold: config.bold ?? false,
      italic: config.italic ?? false,
      cells,
    };
  });
}

export function getEquityCardFigures(apiRows: EquityChangesRow[]): EquityCardFigures {
  const rowsByCode = new Map(apiRows.map((row) => [row.code, row]));
  return {
    opening: rowsByCode.get("400")?.total ?? null,
    profit: rowsByCode.get("610")?.total ?? null,
    revaluation: rowsByCode.get("623")?.oci_components ?? null,
    closing: rowsByCode.get("800")?.total ?? null,
  };
}
